import React from "react";
import news from "../assets/section-image-8.png";
import { Link } from "react-router-dom";
import '@fortawesome/fontawesome-free/css/all.min.css';

const NewsLetter = () => {
  return (
    <section id="newsletter" className="newsletter-section">
      <div className="newsletter-container">
        <div className="newsletter-row">
          <div className="letter-image">
            <img src={news} alt="Loan Updates" />
          </div>
          <div className="newsletter-content">
            <span className="newsletter-subtitle">NEWSLETTER</span>
            <h3>Stay Updated with the Latest Loan Offers and Insights</h3>
            <p>Subscribe to our weekly newsletter to receive exclusive loan offers, market insights, and financial tips from Right Lender.</p>
            
            <form className="newsletter-form">
              <input
                type="email"
                placeholder="Enter your email"
                className="newsletter-input"
                required
              />
              <button type="submit" className="newsletter-button">
                SUBSCRIBE
              </button>
            </form>

            <div className="newsletter-agreement">
              <h6>
                <i className="fas fa-info-circle" style={{ marginRight: "7px", color: "grey" }}></i>
                By subscribing, you agree to our{" "}
                <a href="/terms-conditions" className="newsletter-link">Terms & Conditions</a>{" "}
                and{" "}
                <a href="/privacy-policy" className="newsletter-link">Privacy Policy</a>.
              </h6>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default NewsLetter;
